import { shallowEqual, useSelector } from "react-redux";
import { redirectToPages } from "../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { SystemLogsFilter } from "./system-logs-filter/SystemLogsFilter";
import { SystemLogsTable } from "./system-logs-table/SystemLogsTable";

export function SystemLogsCard() {
  // Getting curret state of System Logs list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.systemLogs }),
    shallowEqual
  );
  const { actionsLoading, isSuccess, type } = currentState;

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);  

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title="Sistem Logları" />
      <CardBody>
        <SystemLogsFilter />
        <SystemLogsTable />
      </CardBody>
    </Card>
  );
}